import DocumentPreviewModal from 'components/document-preview-modal/document-preview-modal';
import DocumentsUpload from 'components/documents-upload/documents-upload';
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { ProofDocumentCard } from './ProofDocumentCard';

type Props = {
  document?: File;
  onDocumentChange: (document?: File) => void;
  disabled?: boolean;
};

export const ProofDocumentSelector: FunctionComponent<Props> = ({
  document,
  onDocumentChange,
  disabled = false,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string>();

  useEffect(() => {
    if (!document) {
      setPreviewUrl(undefined);
      return;
    }
    const url = URL.createObjectURL(document);
    setPreviewUrl(url);
    return (): void => URL.revokeObjectURL(url);
  }, [document]);

  const handleDocumentsChanged = useCallback(
    (documents: { file: File }[]) => {
      onDocumentChange(documents[0]?.file);
    },
    [onDocumentChange],
  );

  if (!document) {
    return (
      <DocumentsUpload
        onDocumentsChanged={handleDocumentsChanged}
        label="Ajouter le document justificatif"
        maxFiles={1}
      />
    );
  }

  return (
    <>
      <ProofDocumentCard name={document.name} status="selected">
        <Button
          basic
          color="blue"
          type="button"
          disabled={!previewUrl || disabled}
          onClick={(): void => setIsPreviewOpen(true)}
        >
          <Icon name="eye" />
          Aperçu
        </Button>
        <Button
          basic
          color="red"
          type="button"
          disabled={disabled}
          onClick={(): void => onDocumentChange(undefined)}
        >
          <Icon name="trash alternate outline" />
          Retirer
        </Button>
      </ProofDocumentCard>
      <DocumentPreviewModal
        open={isPreviewOpen}
        onClose={(): void => setIsPreviewOpen(false)}
        document={
          previewUrl
            ? {
                mimeType: document.type,
                name: document.name,
                url: previewUrl,
              }
            : undefined
        }
      />
    </>
  );
};
